import { render, staticRenderFns } from "./CoreMonacoEditor.vue?vue&type=template&id=2cd2ed17"
import script from "./CoreMonacoEditor.vue?vue&type=script&lang=js"
export * from "./CoreMonacoEditor.vue?vue&type=script&lang=js"
import style0 from "./CoreMonacoEditor.vue?vue&type=style&index=0&id=2cd2ed17&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports